export const sortByEnum = Object.freeze([
  {
    key: 1,
    value: "DESC",
    label: "Ascending(A-Z)",
  },
  {
    key: 2,
    value: "ASC",
    label: "Descending(Z-A)",
  },
]);
export const genderEnum = Object.freeze([
  {
    key: 1,
    value: 1,
    label: "Male",
  },
  {
    key: 2,
    value: 2,
    label: "Female",
  },
  {
    key: 3,
    value: 3,
    label: "Other",
  },
]);

export const saleOrderStatusEnum = Object.freeze({
  PENDING: 1,
  ACCEPTED: 2,
  COMPLETED: 3,
  CANCELLED: 4,
  REJECTED: 5,
  ON_DELIVERY: 6,
  DELIVERED: 7,
  RETURNED: 8,
  REFUNDED: 9,
});

export const saleOrderStatusList = Object.freeze([
  {
    key: saleOrderStatusEnum.PENDING,
    value: saleOrderStatusEnum.PENDING,
    label: "Pending",
    color: "txt-warning",
    bg: "badge-warning",
  },
  {
    key: saleOrderStatusEnum.ACCEPTED,
    value: saleOrderStatusEnum.ACCEPTED,
    label: "Accepted",
    color: "txt-info",
    bg: "badge-info",
  },
  {
    key: saleOrderStatusEnum.COMPLETED,
    value: saleOrderStatusEnum.COMPLETED,
    label: "Completed",
    color: "txt-success",
    bg: "badge-success",
  },
  {
    key: saleOrderStatusEnum.CANCELLED,
    value: saleOrderStatusEnum.CANCELLED,
    label: "Cancelled",
    color: "txt-danger",
    bg: "badge-danger",
  },
  {
    key: saleOrderStatusEnum.REJECTED,
    value: saleOrderStatusEnum.REJECTED,
    label: "Rejected",
    color: "txt-danger",
    bg: "badge-danger",
  },
  {
    key: saleOrderStatusEnum.ON_DELIVERY,
    value: saleOrderStatusEnum.ON_DELIVERY,
    label: "On Delivery",
    color: "txt-warning",
    bg: "badge-warning",
  },
  {
    key: saleOrderStatusEnum.DELIVERED,
    value: saleOrderStatusEnum.DELIVERED,
    label: "Delivered",
    color: "txt-success",
    bg: "badge-success",
  },
  {
    key: saleOrderStatusEnum.RETURNED,
    value: saleOrderStatusEnum.RETURNED,
    label: "Returned",
    color: "txt-danger",
    bg: "badge-danger",
  },
  {
    key: saleOrderStatusEnum.REFUNDED,
    value: saleOrderStatusEnum.REFUNDED,
    label: "Refunded",
    color: "txt-danger",
    bg: "badge-danger",
  },
]);

export const saleOrderPaymentStatusEnum = Object.freeze({
  PENDING: 1,
  RECEIVED: 2,
  FAILED: 3,
  FULL_REFUNDED: 4,
  PARTIALLY_REFUNDED: 5,
  DECLINED: 6,
});

export const saleOrderPaymentStatusList = Object.freeze([
  {
    key: saleOrderPaymentStatusEnum.PENDING,
    value: saleOrderPaymentStatusEnum.PENDING,
    label: "Pending",
    color: "txt-warning",
    bg: "badge-warning",
  },
  {
    key: saleOrderPaymentStatusEnum.RECEIVED,
    value: saleOrderPaymentStatusEnum.RECEIVED,
    label: "Received",
    color: "txt-success",
    bg: "badge-success",
  },
  {
    key: saleOrderPaymentStatusEnum.FAILED,
    value: saleOrderPaymentStatusEnum.FAILED,
    label: "Failed",
    color: "txt-danger",
    bg: "badge-danger",
  },
  {
    key: saleOrderPaymentStatusEnum.FULL_REFUNDED,
    value: saleOrderPaymentStatusEnum.FULL_REFUNDED,
    label: "Full Refund",
    color: "txt-info",
    bg: "badge-info",
  },
  {
    key: saleOrderPaymentStatusEnum.PARTIALLY_REFUNDED,
    value: saleOrderPaymentStatusEnum.PARTIALLY_REFUNDED,
    label: "Partially Refunded",
    color: "txt-info",
    bg: "badge-info",
  },
  {
    key: saleOrderPaymentStatusEnum.DECLINED,
    value: saleOrderPaymentStatusEnum.DECLINED,
    label: "Declined",
    color: "txt-danger",
    bg: "badge-danger",
  },
]);

export const saleOrderDeliveryStatusEnum = Object.freeze({
  PENDING: 1,
  ON_DELIVERY: 2,
  DELIVERED: 3,
  ATTEMPTED_DELIVERY: 4,
  DELIVERY_FAILED: 5,
});

export const saleOrderDeliveryStatusList = Object.freeze([
  {
    key: saleOrderDeliveryStatusEnum.PENDING,
    value: saleOrderDeliveryStatusEnum.PENDING,
    label: "Pending",
    color: "txt-warning",
    bg: "badge-warning",
  },
  {
    key: saleOrderDeliveryStatusEnum.ON_DELIVERY,
    value: saleOrderDeliveryStatusEnum.ON_DELIVERY,
    label: "On Delivery",
    color: "txt-info",
    bg: "badge-info",
  },
  {
    key: saleOrderDeliveryStatusEnum.DELIVERED,
    value: saleOrderDeliveryStatusEnum.DELIVERED,
    label: "Delivered",
    color: "txt-success",
    bg: "badge-success",
  },
  {
    key: saleOrderDeliveryStatusEnum.ATTEMPTED_DELIVERY,
    value: saleOrderDeliveryStatusEnum.ATTEMPTED_DELIVERY,
    label: "Attempted Delivery",
    color: "txt-danger",
    bg: "badge-danger",
  },
  {
    key: saleOrderDeliveryStatusEnum.DELIVERY_FAILED,
    value: saleOrderDeliveryStatusEnum.DELIVERY_FAILED,
    label: "Delivery Failed",
    color: "txt-danger",
    bg: "badge-danger",
  },
]);

export const promotionDiscountType = Object.freeze([
  {
    key: 1,
    value: 1,
    label: "Percentage %",
  },
  {
    key: 2,
    value: 2,
    label: "Amount $",
  },
]);

export const promotionDiscountMethod = Object.freeze([
  {
    key: 1,
    value: 1,
    label: "Category Discount",
  },
  {
    key: 2,
    value: 2,
    label: "Product Discount",
  },
  {
    key: 3,
    value: 3,
    label: "Coupon Code",
  },
]);

export const promotionSortByEnum = Object.freeze([
  {
    key: 1,
    value: "NEWEST",
    label: "Newest",
  },
  {
    key: 2,
    value: "OLDEST",
    label: "Oldest",
  },
]);

export const languageAppEnum = Object.freeze([
  {
    key: 1,
    value: 1,
    label: "Mobile App",
  },
  {
    key: 2,
    value: 2,
    label: "Web Client",
  },
  {
    key: 3,
    value: 3,
    label: "Web Admin",
  },
]); //1:MOBILE_APP_SHOP, 2:WEB_APP_SHOP, 3:WEB_APP_BACKOFFICE, 4:GLOBAL

export const settingApps = [
  { id: 1, name: "Mobile App Shop", key: "MOBILE_APP_SHOP" },
  { id: 2, name: "Web App Shop", key: "WEB_APP_SHOP" },
  { id: 3, name: "Web App Backoffice", key: "WEB_APP_BACKOFFICE" },
  { id: 4, name: "Global", key: "GLOBAL" },
];

export const statuses = [
  { id: 1, name: "Active", key: "ACTIVE" },
  { id: 2, name: "Inactive", key: "INACTIVE" },
];

export const optionControlTypes = [
  { id: 1, name: "Radio" },
  { id: 2, name: "Dropdown" },
];

export const shippingFeeTypeEnum = Object.freeze({
  DISTANCE: "DISTANCE",
  GEO_LOCATION: "GEO_LOCATION",
});

export const stockTransactionTypeEnum = Object.freeze({
  SALE_ORDER: 1,
  STOCK_IN: 2,
  STOCK_OUT: 3,
  STOCK_TRANSFER: 4,
  STOCK_ADJUSTMENT: 5,
  STOCK_RECONCILE: 6,
});

export const stockTransactionTypeLists = [
  {
    key: stockTransactionTypeEnum.SALE_ORDER,
    value: stockTransactionTypeEnum.SALE_ORDER,
    label: "stockSaleOrder",
  },
  {
    key: stockTransactionTypeEnum.STOCK_IN,
    value: stockTransactionTypeEnum.STOCK_IN,
    label: "stockIn",
  },
  {
    key: stockTransactionTypeEnum.STOCK_OUT,
    value: stockTransactionTypeEnum.STOCK_OUT,
    label: "stockOut",
  },
  {
    key: stockTransactionTypeEnum.STOCK_TRANSFER,
    value: stockTransactionTypeEnum.STOCK_TRANSFER,
    label: "stockTransfer",
  },
  {
    key: stockTransactionTypeEnum.STOCK_ADJUSTMENT,
    value: stockTransactionTypeEnum.STOCK_ADJUSTMENT,
    label: "stockAdjustment",
  },
  {
    key: stockTransactionTypeEnum.STOCK_RECONCILE,
    value: stockTransactionTypeEnum.STOCK_RECONCILE,
    label: "stockReconcile",
  },
];
